module.exports = __webpack_public_path__ + "band_16_son.2999abbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_16_son.png
// module id = 5VvW
// module chunks = 0